module.exports = __webpack_public_path__ + "static/media/Lruler.a2573ce0.png";